import { ACTIONS } from "app/store/actions"
import { INotification, INotificationSettings } from "notification/model"
import { Action } from "redux"

export interface INotificationSettingsAction extends Action {
  settings: INotificationSettings
}

export interface INotificationAddAction extends Action {
  notifications: INotification[]
}

export interface INotificationLoadingAction extends Action {
  isLoading: boolean
}

export interface INotificationErrorAction extends Action {
  hasError: boolean
}

export interface INotificationSliderVisibilityAction extends Action {
  isOpened: boolean
}

export interface INotificationMarkAsReadAction extends Action {
  notificationIds: number[]
}

export const notificationActionCreator = {
  setIsLoadingNotificationSettings(isLoading: boolean): INotificationLoadingAction {
    return {
      type: ACTIONS.NOTIFICATION_SETTINGS_IS_LOADING,
      isLoading
    }
  },
  setHasLoadingNotificationSettingsError(hasError: boolean): INotificationErrorAction {
    return {
      type: ACTIONS.NOTIFICATION_SETTINGS_HAS_LOADING_ERROR,
      hasError
    }
  },
  setIsUpdatingNotificationSettings(isLoading: boolean): INotificationLoadingAction {
    return {
      type: ACTIONS.NOTIFICATION_SETTINGS_IS_UPDATING,
      isLoading
    }
  },
  notificationSettingsChange(settings: INotificationSettings): INotificationSettingsAction {
    return {
      type: ACTIONS.NOTIFICATION_SETTINGS_CHANGE,
      settings
    }
  },
  notificationSettingsUpdated(settings: INotificationSettings): INotificationSettingsAction {
    return {
      type: ACTIONS.NOTIFICATION_SETTINGS_UPDATED,
      settings
    }
  },
  addNotifications(notifications: INotification[]): INotificationAddAction {
    return {
      type: ACTIONS.NOTIFICATION_ADD,
      notifications
    }
  },
  setSliderVisibility(isOpened: boolean): INotificationSliderVisibilityAction {
    return {
      type: ACTIONS.NOTIFICATION_VISIBILITY,
      isOpened
    }
  },
  setIsLoadingNotifications(isLoading: boolean): INotificationLoadingAction {
    return {
      type: ACTIONS.NOTIFICATION_IS_LOADING,
      isLoading
    }
  },
  setHasLoadingNotificationsError(hasError: boolean): INotificationErrorAction {
    return {
      type: ACTIONS.NOTIFICATION_HAS_LOADING_ERROR,
      hasError
    }
  },
  setNotificationsAsRead(notificationIds: number[]): INotificationMarkAsReadAction {
    return {
      type: ACTIONS.NOTIFICATION_MARK_AS_READ,
      notificationIds
    }
  }
}
